export default "__VITE_ASSET__Z3XN4YzU__"